
import { defineComponent, onMounted } from 'vue';
import ProfileEditPersonal from '../components/Edit/ProfileEditPersonal.vue';
import ProfileEditWorkplaces from '../components/Edit/ProfileEditWorkplaces.vue';
import ProfileEditEducation from '../components/Edit/ProfileEditEducations.vue';
import ProfileEditContacts from '../components/Edit/ProfileEditContacts.vue';
// eslint-disable-next-line import/no-cycle
import MonitoringService from '@/services/MonitoringService';

export default defineComponent({
  components: {
    ProfileEditPersonal,
    ProfileEditWorkplaces,
    ProfileEditEducation,
    ProfileEditContacts,
  },
  setup() {
    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    return {
    };
  },

});
